/* eslint-disable*/

import { Container, Grid, Typography, Box } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { currentchannel } from 'feactures/channel/channelSlice';
import {
  selectAmazonCategoryShareGraph,
  selectRakutenCategoryShareGraph,
  selectYahooCategoryShareGraph
} from 'feactures/brand/categoryBrandShareSlice';
import BrandItemShareLabel from 'components/molecules/dashboard/BrandItemShareLabel';
import { useLocation, useParams } from 'react-router';
import CategorySharegraph from 'components/molecules/dashboard/CategorySharegraph';

const BrandItemShare = () => {
  // 実際のデータはuseEffectで取得しreduxへ
  const categoryShareAmazonGraphData = useSelector(
    selectAmazonCategoryShareGraph
  );
  const categoryShareRakutenGraphData = useSelector(
    selectRakutenCategoryShareGraph
  );
  const categoryShareYahooGraphData = useSelector(
    selectYahooCategoryShareGraph
  );
  const channel = useSelector(currentchannel);
  const location = useLocation();
  const path = location.pathname;

  let categoryShareGraphData = {
    sales: [],
    percentage: [],
    label: [],
    cumulative_percentages: []
  };

  if (channel == 1) {
    categoryShareGraphData = categoryShareAmazonGraphData.graphdata;
  } else if (channel == 2) {
    categoryShareGraphData = categoryShareRakutenGraphData.graphdata;
  } else if (channel == 3) {
    categoryShareGraphData = categoryShareYahooGraphData.graphdata;
  }

  const sales = categoryShareGraphData.sales;
  const count = sales.filter((item) => item >= 1).length;
  const hasOneOrMore = count >= 1;

  return (
    <>
      <Container maxWidth={false}>
        <Grid container rowSpacing={0.3} columnSpacing={1.5} height={364.9}>
          <>
            <Grid itemxs={12} mb={1}>
              {path === '/app/brandcomparison' ? (
                <Typography fontSize="14px" fontWeight="bold">
                  競合社店舗：商品別売上シェア
                </Typography>
              ) : (
                <BrandItemShareLabel />
              )}
            </Grid>
            <Grid item xs={12}>
              {hasOneOrMore ? (
                <>
                  {/* 円グラフ */}
                  <CategorySharegraph graphdata={categoryShareGraphData} />
                </>
              ) : (
                <Box display="flex" justifyContent="center">
                  <Typography fontSize={15}>
                    表示できるデータがありません
                  </Typography>
                </Box>
              )}
            </Grid>
          </>
        </Grid>
      </Container>
    </>
  );
};

export default BrandItemShare;
